import React from 'react';
import './styling.css';

// Parse text with markdown-style links [Link Text](URL) into HTML
function parseTextWithLinks(text) {
  if (!text) return '';
  
  // Match markdown-style links: [text](url)
  const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = linkRegex.exec(text)) !== null) {
    // Add text before the link
    if (match.index > lastIndex) {
      parts.push(text.substring(lastIndex, match.index));
    }
    
    // Add the link
    const linkText = match[1];
    const url = match[2];
    parts.push(
      <a
        key={match.index}
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: '#0066cc', textDecoration: 'underline' }}
      >
        {linkText}
      </a>
    );
    
    lastIndex = match.index + match[0].length;
  }

  // Add remaining text after last link
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }

  return parts.length > 0 ? parts : text;
}

function DisclosureComponent({ question, checked, onChange }) {
  const labelContent = parseTextWithLinks(question.Text);

  return (
    <div className="shared-padding disclosure-row">
      <input
        type="checkbox"
        id={question.ID}
        checked={!!checked}
        onChange={(e) => onChange(e.target.checked)}
        className="disclosure-input"
      />
      <label htmlFor={question.ID} className="disclosure-label">
        {labelContent}
      </label>
    </div>
  );
}

export default DisclosureComponent;
